import {Injectable} from '@angular/core'
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpRequest,
} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {Asset, Domain} from '@app/core/services/rest-api.model'
import {
  ApiSearchRequest,
  ApiSearchResponse,
} from '@app/core/services/api.interface'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

export {Asset} from '@app/core/services/rest-api.model'

export interface GetAssetsRequest extends ApiSearchRequest {
  domain?: string
}

export interface GetAssetsResponse extends ApiSearchResponse<Asset> {}

@Injectable()
export class AssetService {
  constructor(
    private http: HttpClient,
    private contextSvc: ContextService,
    private logger: LoggerService,
  ) {}

  d

  public getAvailableTerminalAssets(terminalID: string): Observable<Asset[]> {
    const url = 'api://Terminals/' + terminalID + '/AvailableConfigAssets '
    return this.http.get<Asset[]>(url).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public getAssets(domain: string): Observable<Asset[]> {
    const url = 'api://Domains/' + domain + '/ConfigAssets'
    return this.http.get<Asset[]>(url).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public getAsset(domain: string, id: number): Observable<Asset> {
    const url = 'api://Domains/' + domain + '/ConfigAssets/' + id
    return this.http.get<Asset>(url).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public postAsset(domain: string, asset: Asset): Observable<Asset> {
    const url = 'api://Domains/' + domain + '/ConfigAssets'
    return this.http.post<Asset>(url, asset).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public deleteAsset(domain: Domain, id: number): Observable<Asset> {
    const url = 'api://Domains/' + domain.code + '/ConfigAssets/' + id
    return this.http.delete<Asset>(url).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public downloadAsset(domain: Domain, id: number) {
    const url = `api://Domains/${domain.code}/ConfigAssets/${id}/Resource`
    return this.http.get(url, {responseType: 'blob'}).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public downloadAssetWithDomainString(domain: string, id: number) {
    const url = `api://Domains/${domain}/ConfigAssets/${id}/Resource`
    return this.http.get(url, {responseType: 'blob'}).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public postAssetResource(
    domain: string,
    id: number,
    file: File,
  ): Observable<HttpEvent<any>> {
    const url = 'api://Domains/' + domain + '/ConfigAssets/' + id + '/Resource'
    const formData = new FormData()
    formData.append('file', file)
    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      responseType: 'json',
    })
    return this.http.request(req).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  createAsset(domain: Domain, data: any): Observable<Asset> {
    const asset: Asset = {
      name: data.name,
      fileName: data.fileName,
    }
    return this.postAsset(domain.code, asset)
  }

  private handleError(err: Error) {
    if (err instanceof HttpErrorResponse) {
      if (err.error) {
        throw new Error(err.error.description)
      } else {
        throw new Error('Error: ' + err.status + ' => ' + err.message)
      }
    }
  }

  updateAsset(domain: Domain, asset: Asset): Observable<Asset> {
    const url = 'api://Domains/' + domain.code + '/ConfigAssets/' + asset.id
    return this.http.put<Asset>(url, asset).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }
}
